var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 24,
  fill: "none",
  viewBox: "0 0 26 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#212831",
  fillRule: "evenodd",
  stroke: "#212831",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.5,
  d: "M11.816 1.35c.382-1.133 1.986-1.133 2.369 0L16.5 8.217l7.247.082c1.197.013 1.692 1.538.732 2.252l-5.815 4.326 2.162 6.917c.357 1.142-.94 2.085-1.916 1.392L13 18.993 7.09 23.186c-.976.693-2.274-.25-1.917-1.392l2.162-6.917L1.52 10.55c-.96-.714-.464-2.239.732-2.252L9.5 8.217zM13 2.532l-2.137 6.333a1.25 1.25 0 0 1-1.17.85L3.01 9.79l5.363 3.99c.426.316.605.868.447 1.375l-1.994 6.38 5.45-3.868a1.25 1.25 0 0 1 1.447 0l5.451 3.867-1.993-6.379a1.25 1.25 0 0 1 .447-1.376L22.99 9.79l-6.683-.075a1.25 1.25 0 0 1-1.17-.85z",
  clipRule: "evenodd"
})));
export default SvgStar;